var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1 29h20.1214v28h-20.1214zm0 0c0-14.3728 5.09654-23.89803 13.4143-28m16.7678 28h20.1214v28h-20.1214zm0 0c0-14.3728 5.0966-23.89803 13.4143-28","stroke":"#80d8d0","strokeMiterlimit":"10","strokeWidth":"2"}));
}

QuoteInline.defaultProps = {"fill":"none","height":"58","viewBox":"0 0 53 58","width":"53"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
